<template>
  <div class="d-flex gap-2 flex-wrap">
    <a :href="downloadUrl" class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 action-btn">
      Descarga reporte
    </a>
    <button @click="$emit('disable-users')" class="btn bg-utel text-white rounded-8 action-btn">
      Deshabilitar Administradores
    </button>
    <button @click="$emit('bulk-upload')" class="btn bg-utel text-white rounded-8 action-btn">
      Carga masiva
    </button>
    <button @click="$emit('add-user')" class="btn bg-utel text-white rounded-8 action-btn">
      Agregar administrador
    </button>
  </div>
</template>

<script>
export default {
  name: 'UserActions',
  
  props: {
    downloadUrl: { type: String, required: true }
  },
  
  emits: ['disable-users', 'bulk-upload', 'add-user']
}
</script>

<style scoped>
.action-btn {
  padding: 8px 16px;
  margin: 4px 2px;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .action-btn {
    width: 100%;
    margin: 2px 0;
  }
}
</style>